import { ref, computed } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-304ef0d4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "custom-name-cell"
};
import { nextTick } from 'vue';
import { EditOutlined } from '@ant-design/icons-vue';
import { UNSET_TEXT } from '../hooks/useTimeRange';
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomNameCell',
  props: {
    product: null,
    editable: {
      type: Boolean
    }
  },
  emits: ["start-edit", "cancel-edit", "save"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const inputRef = ref();
    const draft = ref('');
    /** 防止 Enter 保存后 blur 再触发一次 */
    let saved = false;
    const editing = computed(() => props.editable);
    const startEdit = () => {
      draft.value = props.product.customName;
      saved = false;
      emit('start-edit', props.product.productId);
      nextTick(() => {
        var _inputRef$value;
        return (_inputRef$value = inputRef.value) === null || _inputRef$value === void 0 ? void 0 : _inputRef$value.focus();
      });
    };
    const handleSave = () => {
      if (saved) return;
      saved = true;
      const next = draft.value.trim();
      if (next === props.product.customName) {
        // 值未变化：直接退出编辑态，不发起保存请求
        emit('cancel-edit');
        return;
      }
      emit('save', {
        productId: props.product.productId,
        customName: next
      });
    };
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(editing) ? (_openBlock(), _createBlock(_component_a_input, {
        key: 0,
        ref_key: "inputRef",
        ref: inputRef,
        value: draft.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => draft.value = $event),
        size: "small",
        maxlength: 30,
        placeholder: "请输入自定义商品名",
        onPressEnter: handleSave,
        onBlur: handleSave
      }, null, 8, ["value"])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("span", {
        class: _normalizeClass(["display-text", {
          unset: !__props.product.customName
        }])
      }, _toDisplayString(__props.product.customName || _unref(UNSET_TEXT)), 3), _createElementVNode("span", {
        class: "edit-icon",
        onClick: startEdit
      }, [_createVNode(_unref(EditOutlined))])], 64))]);
    };
  }
});